import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { AuthService } from '../../services/auth.service';
import { CommonService } from '../../services/common.service';
import { UpiQrDialogComponent } from '../../common/components/upi-qr-dialog';

@Component({
  selector: 'app-subscription-locked',
  standalone: true,
  imports: [CommonModule, ButtonModule, UpiQrDialogComponent],
  template: `
    <div class="subscription-locked-page flex flex-col items-center justify-center min-h-screen p-6 text-center">
      <div class="max-w-lg">
        @if (isDemo) {
          <h1 class="text-3xl font-semibold mb-4 text-surface-900 dark:text-surface-0">Demo ended</h1>
          <p class="text-lg mb-2 text-muted-color">
            Your demo period has ended. Contact Veer Solutions to activate a subscription and continue.
          </p>
          @if (commonService.clientSubscriptionStatus?.subscriptionEndUtc) {
            <p class="mb-6 text-sm text-muted-color">
              Demo ended on {{ commonService.clientSubscriptionStatus?.subscriptionEndUtc | date:'dd MMM yyyy' }}.
            </p>
          }
        } @else {
          <h1 class="text-3xl font-semibold mb-4 text-surface-900 dark:text-surface-0">Account locked</h1>
          <p class="text-lg mb-2 text-muted-color">
            Your grace period has ended. Access is locked until your subscription is renewed.
          </p>
          <p class="mb-6 text-muted-color">
            Please contact your administrator or support to renew your subscription and restore access.
          </p>
          @if (graceEndDate) {
            <p class="mb-6 text-sm text-muted-color">
              Grace period ended on {{ graceEndDate | date:'dd MMM yyyy' }}.
            </p>
          } @else if (commonService.clientSubscriptionStatus?.subscriptionEndUtc) {
            <p class="mb-6 text-sm text-muted-color">
              Subscription ended on {{ commonService.clientSubscriptionStatus?.subscriptionEndUtc | date:'dd MMM yyyy' }}.
            </p>
          }
        }
        <div class="flex items-center justify-center gap-3">
          @if (veerUpiId && !isDemo) {
            <p-button label="Pay via QR" icon="pi pi-qrcode" [outlined]="true" (onClick)="showQr = true" />
          }
          <p-button label="Logout" (onClick)="logout()"></p-button>
        </div>
      </div>
    </div>

    <app-upi-qr-dialog
      [(visible)]="showQr"
      [heading]="'VMS ' + (commonService.clientSubscriptionStatus?.subscriptionMode ?? '') + ' Renewal'"
      [upiId]="veerUpiId"
      [merchantName]="commonService.clientSubscriptionStatus?.veerUpiMerchantName"
      [amount]="commonService.clientSubscriptionStatus?.amcAmount"
      [note]="renewalNote"
      notConfiguredMessage="UPI payments are not available yet. Please contact Veer Solutions support to renew."
    />
  `
})
export class SubscriptionLocked {
  authService = inject(AuthService);
  commonService = inject(CommonService);
  showQr = false;

  get graceEndDate(): string | undefined {
    return this.commonService.clientSubscriptionStatus?.graceEndUtc;
  }

  get veerUpiId(): string | null | undefined {
    return this.commonService.clientSubscriptionStatus?.veerUpiId;
  }

  get isDemo(): boolean {
    return this.commonService.clientSubscriptionStatus?.planCode === 'demo';
  }

  get renewalNote(): string {
    const prefix = this.commonService.clientSubscriptionStatus?.veerUpiNotePrefix || 'VMS Renewal';
    const clientName = this.commonService.clientDetail?.clientName;
    return clientName ? `${prefix} - ${clientName}` : prefix;
  }

  logout(): void {
    this.authService.logout();
  }
}
